import React from 'react';
import { useSelector } from 'react-redux';

import ModalTypes from 'constants/modalTypes';

import GiftDetails from 'pages/CampaignDetails/components/GiftDetails';
import WinnerGifts from 'pages/Winners/components/Gifts';
import FilterMembers from 'pages/Members/components/Filter';

const MODAL_COMPONENTS = {
  [ModalTypes.GIFT_DETAILS]: GiftDetails,
  [ModalTypes.WINNER_GIFTS]: WinnerGifts,
  [ModalTypes.FILTER_MEMBERS]: FilterMembers,
};

const RootModal = () => {
  const props = useSelector(state => state.modal);
  const { currentModals } = useSelector(state => state.modal);

  if (
    !currentModals ||
    (Object.keys(currentModals).length === 0 && currentModals.constructor === Object)
  ) {
    return null;
  }

  const shownModals = Object.entries(currentModals).map(([modalType, modalProps], i) => {
    const SpecificModal = MODAL_COMPONENTS[modalType];
    return <SpecificModal {...modalProps} {...props} key={modalType} />;
  });

  return shownModals;
};

export default RootModal;
